import React from 'react';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/permissionsTableStyle';
import permissionsTableMapping, { accessLevels } from 'mappings/permissionsTableMapping';

const useStyles = makeStyles(styles);

const PermissionsTable = () => {
	const tableData = permissionsTableMapping();
	const classes = useStyles();

	return (
		<div className='ReactTable -striped -highlight'>
			<table className='rt-table'>
				<thead className='rt-thead -header'>
					<tr className={classnames('rt-tr', classes.tr)}>
						<th className={classnames('rt-th rt-resizable-header', classes.th)}>
							Type
						</th>
						<th className={classnames('rt-th rt-resizable-header', classes.th)}>
							Permission Name
						</th>
						<th className={classnames('rt-th rt-resizable-header', classes.th)}>
							Access Level
						</th>
					</tr>
				</thead>
				<tbody className='rt-tbody'>
					{tableData.map(({ typeName, permissionName, accessLevel }, index) => (
						<tr
							key={index}
							className={classnames(
								'rt-tr',
								classes.tr,
								{ ' -odd': index % 2 === 0 },
								{ ' -even': index % 2 === 1 }
							)}
						>
							<td className={classnames(
								'rt-td',
								classes.td,
								{ [classes.tdBold]: accessLevel === accessLevels.full },
							)}>
								{typeName}
							</td>
							<td className={classnames(
								'rt-td',
								classes.td,
								{ [classes.tdBold]: accessLevel === accessLevels.full },
							)}>
								{permissionName}
							</td>
							<td className={classnames('rt-td', classes.accessLevel, classes.td)}>
								<div
									className={classnames(
										classes.accessLevelIndicator,
										{ [classes.accessLevelIndicatorFull]: accessLevel === accessLevels.full },
										{ [classes.accessLevelIndicatorViewOnly]: accessLevel === accessLevels.read },
									)}
								/>
								<span className={classnames(classes.td, classes.accessLevelLabel)}>
									{accessLevel === accessLevels.full ? 'Full Access' : ''}
									{accessLevel === accessLevels.read ? 'View only' : ''}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
	</div>
	)
};

export default PermissionsTable;
